class HommegirlsArticle extends HTMLElement {
  constructor() {
    super();
    this.initArticleContent();
    this.initHero();
    this.initVideoPlayerInteraction();
  }

  // Inspects each P element for its contents and apply a class
  // which is then styled with CSS
  initArticleContent() {
    this.querySelectorAll('.article__content > p').forEach(el => {
      if (el.querySelectorAll('img').length > 1) {
        el.classList.add('article__images-paragraph');
      } else if (el.querySelector('img')) {
        el.classList.add('article__image-paragraph');
      } else if (el.querySelector('video')) {
        el.classList.add('article__video-paragraph');
      } else if (el.querySelector('iframe')) {
        el.classList.add('article__iframe-paragraph');
      } else {
        el.classList.add('article__text-paragraph');
      }
    });
  }

	// This watches for the Hero section scrolling in / out of the viewport
	// if Hero is in viewport, the header is white. else, it is black.
  initHero() {
    const headerEl = document.querySelector('#shopify-section-header');

    let observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if(entry.isIntersecting) {
          headerEl.classList.add('shopify-section-header--hero-mode')
        } else {
          headerEl.classList.remove('shopify-section-header--hero-mode')
        }
      });
    });

    const articleHeaderEl = this.querySelector('.article-header');
    observer.observe(articleHeaderEl);
  }

  initVideoPlayerInteraction() {
    this.querySelectorAll('.article__content video[autoplay]:not([controls])').forEach(el => {
      el.addEventListener('click', event => {

        if(el.muted) {
          el.muted = false;
          el.removeAttribute('muted');
        } else {
          el.muted = true;
          el.setAttribute('muted', true);
        }
      });
    });
  }
}

customElements.define('hommegirls-article', HommegirlsArticle);
